import React from "react";

const Testimonials = () =>{
    return(
    <>
    <div id="people-says">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="section-heading theme-text-center">
            <h1 className="head-back-light">Testimonials</h1>
            <h2 className="head-after">What Our Clients Say</h2>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="row people-says-carousel">
            <div className="people-says-item">
              <div className="people-says-content">
                <div className="card">
                  <p>
                  I was so impressed with how well Jessica handled my corporate event.
                  She was able to work within my budget and still create a beautiful and memorable event.
                  </p>
                </div>
              </div>
              <div className="people-says-bottom">
                <div className="people-says-bottom-icon">
                  <img src="assets/images/icons/customer1-icon.png" alt="" />
                </div>
                <div className="people-says-bottom-title">
                  <h5>
                    Michael - <span>CEO at Jin Boss Ltd</span>
                  </h5>
                </div>
              </div>
            </div>
            <div className="people-says-item">
              <div className="people-says-content">
                <div className="card">
                  <p>
                  I was very impressed with how helpful my agent was when I was shopping for homeowners insurance.
                   He took the time to explain everything to me and answer all of my questions. 
                   I feel confident that I have the right coverage for my needs.
                  </p>
                </div>
              </div>
              <div className="people-says-bottom">
                <div className="people-says-bottom-title">
                  <h5>Cynthia at Cyndy Law Ferm</h5>
                </div>
                <div className="people-says-bottom-icon">
                  <img src="assets/images/icons/customer2.png" alt="" />
                </div>
              </div>
            </div>
            <div className="people-says-item">
              <div className="people-says-content">
                <div className="card">
                  <p>
                  Sarah was an absolute lifesaver for our wedding! She was so organized and detail-oriented, 
                  and she made sure that everything went off without a hitch. She was also a great communicator 
                  and kept us updated on everything throughout the planning process. I would highly recommend her to
                   anyone looking for an event planner
                  </p>
                </div>
              </div>
              <div className="people-says-bottom">
                <div className="people-says-bottom-title">
                  <h5>Julius</h5>
                </div>
                <div className="people-says-bottom-icon">
                  <img src="assets/images/icons/customer3.png" alt="" />
                </div>
              </div>
            </div>
            <div className="people-says-item">
              <div className="people-says-content">
                <div className="card">
                  <p>
                  I was so impressed with the quality of the car parts I bought from Perennial Link. 
                  They were also very affordable, and the staff was helpful in finding the right parts for my car.
                  </p>
                </div>
              </div>
              <div className="people-says-bottom">
                <div className="people-says-bottom-title">
                  <h5>Eva Asamoah - Ecobank</h5>
                </div>
                <div className="people-says-bottom-icon">
                  <img src="assets/images/icons/customer4.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
    )
}

export default Testimonials;